import {Ajaxinate} from 'ajaxinate';

class InfiniteClick {
  constructor() {
    this.initCollectionInfiniteClick();
    this.initSearchInfiniteClick();
  }

  initCollectionInfiniteClick() {
    document.addEventListener("DOMContentLoaded", () => {
      new Ajaxinate({
        container: '#main-collection-product-grid',
        pagination: '#AjaxinatePagination',
        loadingText: 'Loading more…',
        method: 'click',
      });
    });
  }

  initSearchInfiniteClick() {
    document.addEventListener("DOMContentLoaded", () => {
      new Ajaxinate({
        container: '#main-search-grid',
        pagination: '#AjaxinatePagination',
        loadingText: 'Loading more…',
        method: 'click',
      });
    });
  }
}

export default InfiniteClick;
